const handlers = new Set();

export function registerBeforeLogout(handler) {
  handlers.add(handler);
  return () => handlers.delete(handler);
}

export async function runBeforeLogoutHandlers() {
  const results = await Promise.allSettled([...handlers].map((h) => h()));
  results.forEach((r) => {
    if (r.status === 'rejected') {
      console.error('before-logout handler failed', r.reason);
    }
  });
}
